import { keepPreviousData, queryOptions } from '@tanstack/react-query';

import type {
  CashOperationsFeedQueryParams,
  CashOperationsFeedResponse,
  CashSummaryQueryParams,
  CashSummaryResponse,
} from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

const FEED_PAGE_SIZE = 20;

export const cashKeys = {
  all: () => ['cash'] as const,
  summary: (props: CashSummaryQueryParams) =>
    [...cashKeys.all(), 'summary', props.url, props.locationId] as const,
  operationsFeed: (props: CashOperationsFeedQueryParams) =>
    [
      ...cashKeys.all(),
      'operationsFeed',
      props.url,
      props.locationId,
      props.period,
    ] as const,
};

export const cashQueries = {
  summary: (props: CashSummaryQueryParams) =>
    queryOptions({
      queryKey: cashKeys.summary(props),
      queryFn: () =>
        HttpClient.request<CashSummaryResponse>({
          method: 'GET',
          url: props.url,
          params: { location_id: props.locationId },
        }),
      enabled: !!props.locationId,
      refetchOnWindowFocus: false,
      placeholderData: keepPreviousData,
    }),

  operationsFeed: (props: CashOperationsFeedQueryParams) =>
    queryOptions({
      queryKey: cashKeys.operationsFeed(props),
      queryFn: () =>
        HttpClient.request<CashOperationsFeedResponse>({
          method: 'GET',
          url: props.url,
          params: {
            size_per_page: FEED_PAGE_SIZE,
            sort_column: 'occurred_at',
            sort_direction: 'desc',
            filters: { location: [props.locationId], period: props.period },
          },
        }),
      enabled: !!props.locationId,
      refetchOnWindowFocus: false,
      placeholderData: keepPreviousData,
    }),
};
